import{b as r,c as o}from"./chunk-X37JABN5.mjs";export{r as parseDocumentFromString,o as serializeDocumentIntoString};
/*! For license information please see botframework-webchat-component.internal.mjs.LEGAL.txt */
//# sourceMappingURL=botframework-webchat-component.internal.mjs.map